import { Stack } from "@altimateai/lego";
import { ApiHelper } from "../api/index";
import { useQuery } from "../api";
import { Learning, TaskLabels } from "./types";
import LearningRow from "./LearningRow";
import { useEffect, useState } from "react";
import "./learnings.scss";
import { NoLearningsImage } from "./assets";
import { Alert } from "@altimateai/lego";

interface Props {
  filters?: {
    taskLabel?: keyof typeof TaskLabels;
  };
  learning?: string | null;
}

const LearningsPage = ({ filters, learning }: Props) => {
  const [openId, setOpenId] = useState<string | undefined | null>(learning);
  const { error, data, loading, refetch } = useQuery<{
    train_docs: Learning[];
  }>({
    queryFn: () => ApiHelper.get(`coach/training`, filters),
    enabled: false,
  });

  useEffect(() => {
    refetch();
    // avoid refetching on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = (id: string) => {
    setOpenId(prevId => (prevId === id ? undefined : id));
  };

  return (
    <Stack direction="column" className="learnings">
      {loading ? (
        <p>Loading learnings...</p>
      ) : error ? (
        <Alert color="danger">Error loading learnings: {error.message}</Alert>
      ) : data?.train_docs?.length ? (
        <>
          {data.train_docs.map(learning => (
            <LearningRow
              key={learning.train_doc_uid}
              learning={learning}
              afterDelete={refetch}
              toggle={toggle}
              openId={openId}
            />
          ))}
        </>
      ) : (
        <Stack direction="column" className="align-items-center">
          <NoLearningsImage />
          <h4>No learnings added yet!</h4>
        </Stack>
      )}
    </Stack>
  );
};

export default LearningsPage;
